/* Lagom theme: product section, buy buttons and the sticky bar.
   - Gallery: one slide at a time with thumbnails and arrows, endless in both directions, touch swipe, auto-advance
     (from the prototype's main.js 0c, without the size slide).
   - Packs: picking a variant card updates the price in the buttons (slide animation), the URL (?variant=) and the
     sticky bar; every [data-buy-form] on the page follows the chosen variant of its product.
   - Buy buttons: data-buy-action="add" adds via /cart/add.js and stays on the page (toast, header count, "Added ✓",
     inline errors, no double add); "checkout" adds then goes to /checkout (or replaces the cart with the cart
     permalink when the theme setting "keep cart" is off). Without JS the forms post normally.
   - Batch bar and ship countdown from Lagom.config; the keyboard video; the sticky bar (shows after the hero button
     scrolls out, hides over [data-buybar-hide]). Every query is null-guarded; nothing here can throw on a page
     without these elements. */
(function () {
  'use strict';
  var L = window.Lagom; if (!L || !L.q) { return; }
  /* The product section and the sticky bar both load this file; one run binds everything on the page. */
  if (L.buyLoaded) { return; } L.buyLoaded = true;
  var q = L.q, qa = L.qa, motionOff = L.motionOff, C = L.config || {}, T = C.t || {};

  /* ---------- price text slide (M8) ---------- */
  function swapTextAnimated(el, text) {
    if (!el || el.textContent === text) { return; }
    if (motionOff() || typeof el.animate !== 'function') { el.textContent = text; return; }
    var old = document.createElement('span'), fresh = document.createElement('span');
    old.className = 'price-swap__old'; old.setAttribute('aria-hidden', 'true'); old.textContent = el.textContent;
    fresh.className = 'price-swap__new'; fresh.textContent = text;
    el.textContent = ''; el.classList.add('price-swap'); el.appendChild(fresh); el.appendChild(old);
    var opts = { duration: 250, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' };
    old.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-100%)', opacity: 0 }], opts);
    fresh.animate([{ transform: 'translateY(100%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], opts).onfinish = function () { el.textContent = text; el.classList.remove('price-swap'); };
  }

  /* ---------- packs (variants) ---------- */
  qa('[data-product-card]').forEach(function (card) {
    var pid = card.getAttribute('data-product-id'), handle = card.getAttribute('data-product-url');
    var inputs = qa('.bundle__input', card);
    if (!inputs.length) { return; }
    function selected() { var i = inputs.filter(function (x) { return x.checked; })[0] || inputs[0]; return i; }
    var initial = true;
    function render() {
      var i = selected(), price = i.getAttribute('data-price-money'), vid = i.value, avail = i.getAttribute('data-available') === 'true';
      var swapText = initial ? function (el, t) { if (el) { el.textContent = t; } } : swapTextAnimated;   // no slide on the first paint
      var qty = parseInt(i.getAttribute('data-qty'), 10) || 1;   // packs are quantities of the one product
      qa('.bundle__option', card).forEach(function (o) { var x = q('.bundle__input', o); o.classList.toggle('is-selected', !!x && x.checked); });
      qa('[data-buy-form]').forEach(function (f) {
        var h = q('[data-buy-variant]', f), fp = f.getAttribute('data-product-id');
        if (!h || (fp && fp !== pid)) { return; }   // the forms of this product (the card, the sticky bar)
        h.value = vid;
        var n = q('[name="quantity"]', f); if (n) { n.value = qty; }
        var b = q('button[type="submit"]', f); if (b) { b.disabled = !avail; }
        qa('[data-bundle-selected-price], [data-price="now"]', f).forEach(function (el) { swapText(el, price); });
      });
      qa('[data-bundle-selected-price]:not([data-buy-form] [data-bundle-selected-price])').forEach(function (el) { if (!el.closest('[data-buy-form]')) { swapText(el, price); } });
      qa('[data-buybar-price]').forEach(function (el) { swapText(el, price); });
      /* The hero's "Buy now · price" always shows the single phone. */
      var one = inputs.filter(function (x) { return x.getAttribute('data-qty') === '1'; })[0] || inputs[0];
      qa('.hero__primary [data-price="now"]').forEach(function (el) { swapText(el, one.getAttribute('data-price-money')); });
      qa('[data-buybar-was]').forEach(function (el) { var w = i.getAttribute('data-compare-money'); el.textContent = w || ''; el.hidden = !w; });
      if (handle && window.history && window.history.replaceState && card.hasAttribute('data-main-product')) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', vid); window.history.replaceState({}, '', u.toString()); } catch (e) { /* ignore */ }
      }
      document.dispatchEvent(new CustomEvent('lagom:pack', { detail: { id: vid, price: price, productId: pid } }));
      initial = false;
    }
    inputs.forEach(function (i) { i.addEventListener('change', function () {
      render();
      var cta = q('[data-buy-form] button[type="submit"], .buy__cta', card);
      if (cta) { var r = cta.getBoundingClientRect(); if (r.bottom > window.innerHeight - 12 || r.top < 0) { cta.scrollIntoView({ block: 'nearest', behavior: motionOff() ? 'auto' : 'smooth' }); } }
      L.track('pack_select', i.getAttribute('data-variant-title'));
    }); });
    render();
  });

  /* ---------- buy forms: add to cart or straight to checkout ---------- */
  var busy = false;
  qa('[data-buy-form]').forEach(function (form) {
    function reset() { busy = false; var b = q('button[type="submit"]', form); if (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); } }
    window.addEventListener('pageshow', function (e) { if (e.persisted) { reset(); } });   /* back from checkout: the page is restored as it was */
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && busy) { window.setTimeout(reset, 400); } });
    form.addEventListener('submit', function (e) {
      if (!window.fetch) { return; }   // plain submit
      e.preventDefault();
      if (busy) { return; }            // no double adds on a fast double tap
      var action = form.getAttribute('data-buy-action'), id = (q('[data-buy-variant]', form) || {}).value, qty = parseInt((q('[name="quantity"]', form) || {}).value, 10) || 1;
      var btn = q('button[type="submit"]', form), err = q('[data-buy-error]', form), label = btn && q('.buy__cta-label', btn);
      if (!id || !btn) { return; }
      busy = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); if (err) { err.hidden = true; }
      window.setTimeout(function () { if (busy) { reset(); } }, 10000);
      /* Every buy button (also "Secure Checkout") adds to the cart and opens the cart drawer; checkout is the drawer's button. */
      L.cart.add(id, qty, { silent: false }).then(function () {
        busy = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        if (label) { var was = label.innerHTML; label.textContent = T.addedShort || 'Added ✓'; window.setTimeout(function () { label.innerHTML = was; }, 1800); }
        L.track(action === 'checkout' ? 'checkout_click' : 'add_to_cart');
      }).catch(function (ex) {
        busy = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        var msg = (ex && ex.message) || (C.t && C.t.error) || 'Something went wrong. Please try again.';
        if (err) { err.textContent = msg; err.hidden = false; }
      });
    });
  });

  /* ---------- gallery ---------- */
  qa('[data-gallery]').forEach(function (gal) {
    var track = q('[data-gallery-track]', gal), thumbsWrap = q('[data-gallery-thumbs]', gal.parentNode) || q('[data-gallery-thumbs]', gal);
    if (!track) { return; }
    function slides() { return qa('.buy__slide', track); }
    function setActive(name) { if (thumbsWrap) { qa('.buy__thumb', thumbsWrap).forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-goto') === name ? 'true' : 'false'); }); } }
    var cur = -1, anims = [], EASE = 'cubic-bezier(0.32, 0.72, 0, 1)', D = 560;
    function current() { return Math.max(0, cur); }
    function finishAll() { anims.forEach(function (a) { a.cancel(); }); anims = []; }
    function leave(from, dir, startX) {
      from.classList.add('is-leaving');
      var W = track.clientWidth, sx = startX || 0, p0 = Math.min(1, Math.abs(sx) / W);
      var a = from.animate([
        { transform: 'translate3d(' + (sx * 0.28) + 'px, 0, 0) scale(' + (1 - 0.06 * p0) + ')', opacity: 1 - 0.6 * p0 },
        { transform: 'translate3d(' + (-dir * 28) + '%, 0, 0) scale(0.94)', opacity: 0 }], { duration: D, easing: EASE, fill: 'forwards' });
      a.onfinish = function () { from.classList.remove('is-leaving'); a.cancel(); };
      anims.push(a);
    }
    function goIndex(i, dir, dragPx) {
      var list = slides(), n = list.length;
      if (!n) { return; }
      var k = ((i % n) + n) % n;
      if (k === cur) { return; }
      var from = cur >= 0 ? list[cur] : null, to = list[k];
      if (!dir) { dir = cur < 0 || k > cur || (cur === n - 1 && k === 0) ? 1 : -1; if (cur === 0 && k === n - 1) { dir = -1; } }
      finishAll();
      list.forEach(function (sl) { sl.classList.toggle('is-active', sl === to); sl.classList.remove('is-leaving'); sl.style.transform = ''; sl.style.opacity = ''; });
      if (from && !motionOff() && to.animate) {
        var W = track.clientWidth, start = dir * W + (dragPx || 0);
        anims.push(to.animate([{ transform: 'translate3d(' + start + 'px, 0, 0)' }, { transform: 'translate3d(0, 0, 0)' }], { duration: D, easing: EASE }));
        leave(from, dir, dragPx);
      }
      cur = k;
      setActive(to.getAttribute('data-slide'));
    }
    var tx = null, ty = 0, dx = 0, t0 = 0, dragging = false, paused = false, hover = false, visible = false;
    function peek(d) { var list = slides(), n = list.length; return list[((cur + d) % n + n) % n]; }
    track.addEventListener('touchstart', function (e) { if (slides().length < 2 || e.touches.length > 1 || (window.Lagom && Lagom.zoomed && Lagom.zoomed())) { tx = null; return; } finishAll(); tx = e.touches[0].clientX; ty = e.touches[0].clientY; dx = 0; dragging = false; t0 = Date.now(); }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (tx === null) { return; }
      if (e.touches.length > 1) { endSwipe(); return; }   /* a second finger = pinch zoom: the browser's */
      dx = e.touches[0].clientX - tx; var dy = e.touches[0].clientY - ty;
      if (!dragging) { if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { tx = null; return; } if (Math.abs(dx) > 8) { dragging = true; paused = true; } }
      if (!dragging) { return; }
      if (e.cancelable) { e.preventDefault(); }   /* the gallery owns this swipe: in-app browsers must not read it as "back" */
      var W = track.clientWidth, list = slides(), d = dx < 0 ? 1 : -1, nb = peek(d), active = list[cur];
      list.forEach(function (sl) { if (sl !== active && sl !== nb) { sl.classList.remove('is-leaving'); sl.style.transform = ''; } });
      var p0 = Math.min(1, Math.abs(dx) / W);
      active.style.transform = 'translate3d(' + (dx * 0.28) + 'px, 0, 0) scale(' + (1 - 0.06 * p0) + ')'; active.style.opacity = String(1 - 0.6 * p0);
      nb.classList.add('is-leaving'); nb.style.zIndex = 3; nb.style.transform = 'translate3d(' + (d * W + dx) + 'px, 0, 0)'; nb.style.opacity = '1';
    }, { passive: false });
    function endSwipe() {
      if (tx === null) { return; }
      tx = null;
      if (!dragging) { return; }
      dragging = false;
      var d = dx < 0 ? 1 : -1, fast = Math.abs(dx) / Math.max(1, Date.now() - t0) > 0.4, nb = peek(d), active = slides()[cur];
      nb.style.zIndex = '';
      if (Math.abs(dx) > 50 || (fast && Math.abs(dx) > 20)) {
        active.style.transform = ''; active.style.opacity = ''; nb.style.transform = ''; nb.style.opacity = '';
        goIndex(cur + d, d, dx);
      } else {
        var W = track.clientWidth, p0 = Math.min(1, Math.abs(dx) / W);
        active.style.transform = ''; active.style.opacity = ''; nb.style.transform = '';
        anims.push(active.animate([{ transform: 'translate3d(' + (dx * 0.28) + 'px, 0, 0) scale(' + (1 - 0.06 * p0) + ')', opacity: 1 - 0.6 * p0 }, { transform: 'none', opacity: 1 }], { duration: 380, easing: EASE }));
        var back = nb.animate([{ transform: 'translate3d(' + (d * W + dx) + 'px, 0, 0)' }, { transform: 'translate3d(' + (d * W) + 'px, 0, 0)' }], { duration: 380, easing: EASE });
        back.onfinish = function () { nb.classList.remove('is-leaving'); };
        anims.push(back);
      }
    }
    track.addEventListener('touchend', endSwipe, { passive: true });
    track.addEventListener('touchcancel', endSwipe, { passive: true });
    goIndex(0);
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-goto]'); if (!t) { return; }
        var i = slides().findIndex(function (s) { return s.getAttribute('data-slide') === t.getAttribute('data-goto'); });
        if (i >= 0) { goIndex(i); paused = true; }
      });
    }
    qa('[data-gallery-prev], [data-gallery-next]', gal).forEach(function (b) {
      b.addEventListener('click', function () { var d = b.hasAttribute('data-gallery-next') ? 1 : -1; goIndex(current() + d, d); paused = true; });
      b.hidden = slides().length < 2;
    });
    if (!motionOff() && slides().length > 1) {
      gal.addEventListener('mouseenter', function () { hover = true; });
      gal.addEventListener('mouseleave', function () { hover = false; });
      if ('IntersectionObserver' in window) { new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(track); } else { visible = true; }
      window.setInterval(function () { if (!paused && !hover && visible && !document.hidden) { goIndex(current() + 1, 1); } }, 4000);
    }
  });

  /* ---------- batch bar and ship line ---------- */
  (function () {
    var u = C.urgency || {}, s = C.ship || {};
    qa('[data-batch]').forEach(function (box) {
      var total = parseInt(box.getAttribute('data-total') || u.total, 10) || 0;
      var left = box.hasAttribute('data-left') ? parseInt(box.getAttribute('data-left'), 10) : u.left;
      if (!u.enabled || !(total > 0) || isNaN(left)) { box.hidden = true; return; }
      var reserved = Math.max(0, Math.min(total, total - left));
      var t = q('[data-batch-text]', box); if (t) { t.textContent = L.fill(box.getAttribute('data-text') || '[reserved] of [total] phones reserved', { reserved: reserved, total: total }); }
      var f = q('[data-batch-fill]', box); if (f) { f.style.width = (reserved / total * 100).toFixed(1) + '%'; }
      box.hidden = false;
    });
    /* Delivery block: "Buy within 2 h 10 min – get it Friday, October 30" before the cut-off, else "Buy now – get it …",
       with the ship day below. While a batch is still on its way the Liquid batch line stays. Again once the visitor's
       country is detected, and every minute. */
    var esc = function (x) { return String(x).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
    qa('[data-eta]').forEach(function (eta) {
      var title = q('[data-eta-days]', eta), timer = q('[data-eta-timer]', eta), sub = q('[data-eta-sub]', eta);
      function tick() {
        try {
          var info = L.dispatchInfo(new Date());
          var date = esc(info.single ? info.arriveDate : info.arriveRange);
          if (title) {
            if (info.orderToday) {
              var h = Math.floor(info.minsLeft / 60), m = info.minsLeft % 60;
              title.innerHTML = L.fill(T.buyWithinGet || 'Buy within <strong>[hours] h [minutes] min</strong> – get it [date]', { hours: h, minutes: m, date: date });
            } else { title.innerHTML = L.fill(T.buyNowGet || 'Buy now – get it [date]', { date: date }); }
          }
          if (sub && !info.batchPending) {
            sub.textContent = (info.shipsToday ? T.shipsToday : info.shipTomorrow ? T.shipsTomorrow : L.fill(T.shipsOn || 'Ships [day]', { day: info.shipName })) || '';
          }
          if (timer) { timer.hidden = true; }
        } catch (e) { /* keep the Liquid text */ }
      }
      tick();
      [1500, 4000].forEach(function (ms) { setTimeout(tick, ms); });
      setInterval(tick, 60000);
    });
  })();

  /* ---------- keyboard video ---------- */
  qa('[data-kbd-video]').forEach(function (v) {
    if (L.off && L.off.video) { v.removeAttribute('autoplay'); v.pause(); v.hidden = true; return; }   /* ?off=video (test) */
    var box = v.closest('details'), seen = false;
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('webkit-playsinline', '');
    var ua = navigator.userAgent, ios = /iP(hone|ad|od)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var safari = /Safari\//.test(ua) && !/Chrome\/|Chromium\/|Edg\/|OPR\/|Android/.test(ua);
    if ((ios || safari) && v.getAttribute('data-anim')) {
      /* The animated WebP sits in Files with a 16-byte prefix (Shopify's CDN would otherwise re-encode it to a GIF):
         fetch, strip, show as a blob image. Motion off: the poster. If the fetch fails the video below stays. */
      var img = document.createElement('img');
      img.className = v.className; img.width = 840; img.height = 590; img.decoding = 'async'; img.alt = v.getAttribute('aria-label') || '';
      var swap = function () { if (v.parentNode) { v.parentNode.replaceChild(img, v); } };
      if (motionOff()) { img.src = v.getAttribute('poster'); swap(); return; }
      var started = false;
      var load = function () {
        if (started) { return; } started = true;
        fetch(v.getAttribute('data-anim'), { mode: 'cors', credentials: 'omit' }).then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.arrayBuffer(); }).then(function (buf) {
          var b = new Uint8Array(buf), off = (b[0] === 0x52 && b[1] === 0x49 && b[2] === 0x46 && b[3] === 0x46) ? 0 : 16;
          img.src = URL.createObjectURL(new Blob([buf.slice(off)], { type: 'image/webp' }));
          /* Decoded before it is put in the page: the first open of the tab must not pay for a 1.5 MB animated WebP decode. */
          var p = img.decode ? img.decode() : new Promise(function (ok) { img.onload = ok; });
          p.then(swap, swap);
        }).catch(function () {});
      };
      var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 1500 }); } : function (f) { window.setTimeout(f, 1); };
      if ('IntersectionObserver' in window) { new IntersectionObserver(function (e, io) { if (e[0].isIntersecting) { io.disconnect(); idle(load); } }, { rootMargin: '600px 0px' }).observe(box || v); } else { load(); }   /* the details box: the video has no box while its tab is closed */
      /* fall through: the video keeps working until the image is ready */
    }
    /* Fetched once: nothing until the box is within 300px of the screen, then the file (preload auto); play() on open. */
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (e, io) { if (e[0].isIntersecting) { io.disconnect(); v.preload = 'auto'; } }, { rootMargin: '300px 0px' }).observe(box || v); } else { v.preload = 'auto'; }
    function tabOpen() { return box && box.open && !box.classList.contains('is-collapsed'); }
    function sync() { if (motionOff() || !tabOpen() || !seen) { if (!v.paused) { v.pause(); } return; } var pr = v.play(); if (pr && pr.catch) { pr.catch(function () {}); } }
    if (box) { box.addEventListener('toggle', sync); box.addEventListener('lagom:tab', sync); }
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (e) { seen = e[0].isIntersecting; sync(); }, { threshold: 0.25 }).observe(v); } else { seen = true; }
    v.addEventListener('webkitbeginfullscreen', function () { if (v.webkitExitFullscreen) { v.webkitExitFullscreen(); } });
    if (motionOff()) { v.removeAttribute('autoplay'); v.pause(); }
    sync();
  });

  /* ---------- sticky buy bar ---------- */
  (function () {
    var bar = q('[data-buybar]'), trigger = q('[data-buybar-trigger]') || q('.buy__card');
    if (!bar || !trigger || !('IntersectionObserver' in window)) { return; }
    var past = false, blockers = 0;
    function cookieVisible() { var c = q('[data-cookie]'); return !!c && !c.hidden; }
    var shown = false;
    function render() {
      var show = past && blockers === 0 && !cookieVisible(); bar.classList.toggle('is-visible', show); bar.inert = !show;
      /* The button's 30 s shine (CSS, empty cart) starts over each time the bar comes into view, so the first sweep is seen. */
      if (show && !shown) { var cta = q('.buybar__cta', bar); if (cta && cta.getAnimations) { window.setTimeout(function () { cta.getAnimations({ subtree: true }).forEach(function (a) { if (a.animationName === 'buybar-shine') { a.cancel(); a.play(); } }); }, 400); } }
      shown = show;
    }
    new IntersectionObserver(function (entries) { var e = entries[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; render(); }).observe(trigger);
    var seen = new Map();
    var hideIo = new IntersectionObserver(function (entries) { entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); }); blockers = 0; seen.forEach(function (v) { if (v) { blockers += 1; } }); render(); });
    qa('[data-buybar-hide]').forEach(function (el) { hideIo.observe(el); });
    document.addEventListener('lagom:cookie-closed', render);
    document.addEventListener('lagom:cookie-changed', render);
    render();
  })();
})();
